export default {
    namespaced: true,
    state: {
        courses: undefined,
        schools: undefined
    },
    mutations: {
        courses(state, courses) {
            state.courses = courses
        },
        schools(state, schools) {
            state.schools = schools
        }
    },
    getters: {
        courses: (state) => (isArchived) => {
            return [
                {value: '', text: 'Select a course…'},
                ...state.courses
                    .filter(o => isArchived ? o.isArchived : !o.isArchived)
                    .map(o => ({value: o.id, text: o.title}))
            ]
        },
        schools: (state) => (isArchived) => {
            return [
                {value: '', text: 'Select a school…'},
                ...state.schools
                    .filter(o => isArchived ? o.isArchived : !o.isArchived)
                    .map(o => ({value: o.id, text: o.name}))
            ]
        }
    },
    actions: {
        async courses({state, commit, dispatch, rootState}) {
            if (state.courses === undefined) {
                const {data: {items}} = await dispatch('request/get', {
                    url: 'api/component/odp_courses',
                    params: {
                        fields: ['id', 'title', 'isArchived'],
                        sort: 'title',
                        ...(rootState.user.user.franchiseId && {
                            franchiseId: rootState.user.user.franchiseId
                        })
                    }
                }, {root: true})
                
                commit('courses', items)
            }
        },
        async schools({state, commit, dispatch, rootState}) {
            if (state.schools === undefined) {
                const {data: {values: schoolIds}} = await dispatch('request/get', {
                    url: 'api/component/odp_course_dates/schoolId',
                    params: {schoolId: {gt: 0}}
                }, {root: true})
                
                const {data: {items}} = await dispatch('request/get', {
                    url: 'api/component/odp_schools',
                    params: {
                        fields: ['id', 'name', 'isArchived'],
                        id: schoolIds,
                        sort: 'name',
                        ...(rootState.user.user.franchiseId && {
                            franchiseId: rootState.user.user.franchiseId
                        })
                    }
                }, {root: true})
                
                commit('schools', items)
            }
        }
    }
}